import {
  createRouter,
  createWebHistory
} from "vue-router";
import Home from "../views/system/Home.vue";

const routes = [{
  path: '/',
  redirect: '/dashboard'
}, {
  path: "/",
  name: "Home",
  component: Home,
  children: [{
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: '系统首页'
    },
    component: () => import("../views/system/Dashboard.vue")
  },

    {
      path: "/service",
      name: "service",
      meta: {
        title: '客服聊天',
      },
      component: () => import("../views/system/service.vue")
    },
    {
      path: "/returnVisit",
      name: "returnVisit",
      meta: {
        title: '回访'
      },
      component: () => import("../views/system/returnVisit.vue")
    },
    {
      path: "/addReturns",
      name: "addReturns",
      meta: {
        title: '充值'
      },
      component: () => import("../views/system/addReturns.vue")
    },
    {
      path: "/customer",
      name: "customer",
      meta: {
        title: '我的客户'
      },
      component: () => import("../views/crm/customer.vue")
    },
    {
      path: "/CRMHigh",
      name: "CRMHigh",
      meta: {
        title: '公海客户'
      },
      component: () => import("../views/crm/CRMHigh.vue")
    },
    {
      path: "/CRMDepartmentHigh",
      name: "CRMDepartmentHigh",
      meta: {
        title: '部门公海'
      },
      component: () => import("../views/crm/CRMDepartmentHigh.vue")
    },
    {
      path: "/frequencyLimiting",
      name: "frequencyLimiting",
      meta: {
        title: '出库限频'
      },
      component: () => import("../views/crm/frequencyLimiting.vue")
    },
    {
      path: "/CRMstatistics",
      name: "CRMstatistics",
      meta: {
        title: 'CRM统计报表'
      },
      component: () => import("../views/crm/CRMstatistics.vue")
    },
    {
      path: "/clue",
      name: "clue",
      meta: {
        title: '线索列表'
      },
      component: () => import("../views/crm/clue.vue")
    },
    {
      path: "/groupCall",
      name: "groupCall",
      meta: {
        title: '群呼列表'
      },
      component: () => import("../views/crm/groupCall.vue")
    },
    {
      path: "/taskDesk",
      name: "taskDesk",
      meta: {
        title: '任务中心'
      },
      component: () => import("../views/system/taskDesk.vue")
    },
    {
      path: "/cluePool",
      name: "cluePool",
      meta: {
        title: '线索池'
      },
      component: () => import("../views/crm/cluePool.vue")
    },
    {
      path: "/assignLeads",
      name: "assignLeads",
      meta: {
        title: '线索回收'
      },
      component: () => import("../views/crm/assignLeads.vue")
    },
    {
      path: "/qualityInspection",
      name: "qualityInspection",
      meta: {
        title: '录音质检'
      },
      component: () => import("../views/quality/qualityInspection.vue")
    }, {
      path: "/qualityInspection2",
      name: "qualityInspection2",
      meta: {
        title: '录音检测'
      },
      component: () => import("../views/quality/qualityInspection2.vue")
    }, {
      path: "/inspectionRecords",
      name: "inspectionRecords",
      meta: {
        title: '质检记录'
      },
      component: () => import("../views/quality/inspectionRecords.vue")
    },
    {
      path: "/riskList",
      name: "riskList",
      meta: {
        title: '风险通话列表'
      },
      component: () => import("../views/quality/riskList.vue")
    },
    {
      path: "/riskList2",
      name: "riskList2",
      meta: {
        title: '风险通话列表'
      },
      component: () => import("../views/quality/riskList2.vue")
    }, {
      path: "/AIinspection",
      name: "AIinspection",
      meta: {
        title: 'AI质检'
      },
      component: () => import("../views/quality/AIinspection.vue")
    },
    {
      path: "/record",
      name: "record",
      meta: {
        title: '通话记录'
      },
      component: () => import("../views/quality/record.vue")
    },
    {
      path: "/recording",
      name: "recording",
      meta: {
        title: '录音检测'
      },
      component: () => import("../views/quality/recording.vue")
    },
    {
      path: "/tag",
      name: "tag",
      meta: {
        title: '标签管理',
      },
      component: () => import("../views/crm/tag.vue")
    },

    {
      path: "/customTag",
      name: "customTag",
      meta: {
        title: '字段配置',
      },
      component: () => import("../views/crm/customTag.vue")
    },
    {
      path: "/clueCollection",
      name: "clueCollection",
      meta: {
        title: '领取记录',
      },
      component: () => import("../views/crm/clueCollection.vue")
    },
    {
      path: "/operationRecord",
      name: "operationRecord",
      meta: {
        title: '操作记录',
      },
      component: () => import("../views/crm/operationRecord.vue")
    },
    {
      path: "/CRMsource",
      name: "CRMsource",
      meta: {
        title: '来源配置',
      },
      component: () => import("../views/crm/CRMsource.vue")
    }, {
      path: "/release",
      name: "release",
      meta: {
        title: '释放管理',
      },
      component: () => import("../views/crm/release.vue")
    }, {
      path: "/modou",
      name: "modou",
      meta: {
        title: '模板',
      },
      component: () => import("../views/crm/modou.vue")
    },
    {
      path: "/automaticRecycling",
      name: "automaticRecycling",
      meta: {
        title: '自动回收',
      },
      component: () => import("../views/crm/automaticRecycling.vue")
    },

    {
      path: "/followProgress",
      name: "followProgress",
      meta: {
        title: '跟进阶段配置',
      },
      component: () => import("../views/crm/followProgress.vue")
    },
    {
      path: "/company",
      name: "company",
      meta: {
        title: '企业列表',
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/enterprise/company.vue")
    },

    {
      path: "/deleteRecords",
      name: "deleteRecords",
      meta: {
        title: '删除记录',
        role: ['admin']
      },
      component: () => import("../views/enterprise/deleteRecords.vue")
    },
    {
      path: "/department",
      name: "department",
      meta: {
        title: '部门管理'
      },
      component: () => import("../views/enterprise/department.vue")
    }, {
      path: "/user",
      name: "user",
      meta: {
        title: '员工管理'
      },
      component: () => import("../views/enterprise/user.vue")
    }, {
      path: "/report",
      name: "report",
      meta: {
        title: '员工统计报表',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'subAgent']
      },
      component: () => import("../views/enterprise/report.vue")
    }, {
      path: "/companyStatistics",
      name: "companyStatistics",
      meta: {
        title: '公司统计报表',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'subAgent']
      },
      component: () => import("../views/enterprise/companyStatistics.vue")
    }, {
      path: "/GSAxb",
      name: "GSAxb",
      meta: {
        title: '光速AXB',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'subAgent']
      },
      component: () => import("../views/inventory/GSAxb.vue")
    }, {
      path: "/cjabnormalCall",
      name: "cjabnormalCall",
      meta: {
        title: '长江异常话单',
        permission: true,
        role: ['admin', 'agent', ]
      },
      component: () => import("../views/number/cjabnormalCall.vue")
    }, {
      path: "/agent",
      name: "agent",
      meta: {
        title: '代理商管理',
        permission: true,
        role: ['admin', 'oem']
      },
      component: () => import("../views/enterprise/agent.vue")
    }, {
      path: "/administratorAccount",
      name: "administratorAccount",
      meta: {
        title: '管理员账号',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/enterprise/administratorAccount.vue")
    },
    // {
    // 	path: "/blackListDatabase",
    // 	name: "blackListDatabase",
    // 	meta: {
    // 		title: '黑名单库',
    // 		permission: true,
    // 		role: ['admin', 'agent', 'subAgent']
    // 	},
    // 	component: () => import(
    // 		/* webpackChunkName: "table" */
    // 		"../views/blackListDatabase.vue")
    // },
    {
      path: "/cardType",
      name: "cardType",
      meta: {
        title: '品牌管理',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/crm/cardType.vue")
    }, {
      path: "/businessRecords",
      name: "businessRecords",
      meta: {
        title: '业务记录',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/crm/businessRecords.vue")
    },
    {
      path: "/numberPool",
      name: "numberPool",
      meta: {
        title: '号码池',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/number/numberPool.vue")
    }, {
      path: "/woniunumberPool",
      name: "woniunumberPool",
      meta: {
        title: '蜗牛号码池',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/woniu/woniunumberPool.vue")
    }, {
      path: "/numberControl",
      name: "numberControl",
      meta: {
        title: '漫游管控',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/number/numberControl.vue")
    }, {
      path: "/accountOpeningProgress",
      name: "accountOpeningProgress",
      meta: {
        title: '蜗牛开户进度',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/woniu/accountOpeningProgress.vue")
    }, {
      path: "/accountOpeningProgressCY",
      name: "accountOpeningProgressCY",
      meta: {
        title: 'CY蜗牛开户进度',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/woniu/accountOpeningProgressCY.vue")
    }, {
      path: "/batchAccountClosure",
      name: "batchAccountClosure",
      meta: {
        title: '批量销户',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/woniu/batchAccountClosure.vue")
    }, {
      path: "/batchAccountClosureCY",
      name: "batchAccountClosureCY",
      meta: {
        title: 'CY批量销户',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/woniu/batchAccountClosureCY.vue")
    },
    {
      path: "/woniuRecharge",
      name: "woniuRecharge",
      meta: {
        title: '充值列表',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/woniu/woniuRecharge.vue")
    },
    {
      path: "/blackNameList",
      name: "blackNameList",
      meta: {
        title: '风险黑名单',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/number/blackNameList.vue")
    },
    {
      path: "/subagent",
      name: "subagent",
      meta: {
        title: '子代理列表',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/enterprise/subagent.vue")
    },
    {
      path: "/woniuBill",
      name: "woniuBill",
      meta: {
        title: '蜗牛话单',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/woniu/woniuBill.vue")
    },
    {
      path: "/outboundCallRecords",
      name: "outboundCallRecords",
      meta: {
        title: '外呼记录',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/search/outboundCallRecords.vue")
    }, {
      path: "/shutdownRecord",
      name: "shutdownRecord",
      meta: {
        title: '蜗牛停机记录',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/woniu/shutdownRecord.vue")
    }, {
      path: "/hySA",
      name: "hySA",
      meta: {
        title: '华云SA查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/inventory/hySA.vue")
    }, /* {
      path: "/tagQuery",
      name: "tagQuery",
      meta: {
        title: '标记查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/crm/tagQuery.vue")
    }, */ {
      path: "/programmeManagement",
      name: "programmeManagement",
      meta: {
        title: '方案管理',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/system/programmeManagement.vue")
    },
    {
      path: "/webClue",
      name: "webClue",
      meta: {
        title: '网站线索',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/crm/webClue.vue")
    }, {
      path: "/statistics",
      name: "statistics",
      meta: {
        title: '话单校验',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/number/statistics.vue")
    }, {
      path: "/restartRecordList",
      name: "restartRecordList",
      meta: {
        title: '迪加停复机',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/dijia/restartRecordList.vue")
    }, {
      path: "/CCrestartRecordList",
      name: "CCrestartRecordList",
      meta: {
        title: '长城停复机',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/changcheng/CCrestartRecordList.vue")
    }, {
      path: "/DJfreeze",
      name: "DJfreeze",
      meta: {
        title: '自选套餐冻结',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/dijia/DJfreeze.vue")
    }, {
      path: "/WNrestartRecordList",
      name: "WNrestartRecordList",
      meta: {
        title: '蜗牛停复机',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/woniu/WNrestartRecordList.vue")
    }, {
      path: "/WNrestartRecordListCY",
      name: "WNrestartRecordListCY",
      meta: {
        title: 'CY蜗牛停复机',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/woniu/WNrestartRecordListCY.vue")
    }, {
      path: "/NoShutdownMaintenanceNumber",
      name: "NoShutdownMaintenanceNumber",
      meta: {
        title: '取消停机保号',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/woniu/NoShutdownMaintenanceNumber.vue")
    }, {
      path: "/userInfo",
      name: "userInfo",
      meta: {
        title: '迪加查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/enterprise/userInfo.vue")
    }, {
      path: "/wnQuery",
      name: "wnQuery",
      meta: {
        title: '蜗牛查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/woniu/wnQuery.vue")
    }, {
      path: "/CCQuery",
      name: "CCQuery",
      meta: {
        title: '长城查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/changcheng/CCQuery.vue")
    }, {
      path: "/wnQueryCY",
      name: "wnQueryCY",
      meta: {
        title: 'CY蜗牛查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/woniu/wnQueryCY.vue")
    }, {
      path: "/WNWhitelist",
      name: "WNWhitelist",
      meta: {
        title: '蜗牛批量加白',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/woniu/WNWhitelist.vue")
    }, {
      path: "/WNWhitelistCY",
      name: "WNWhitelistCY",
      meta: {
        title: 'CY蜗牛批量加白',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/woniu/WNWhitelistCY.vue")
    }, {
      path: "/djRecharge",
      name: "djRecharge",
      meta: {
        title: '迪加充值',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/dijia/djRecharge.vue")
    }, {
      path: "/wnRecharge",
      name: "wnRecharge",
      meta: {
        title: '蜗牛充值',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/woniu/wnRecharge.vue")
    }, {
      path: "/preDeposit",
      name: "preDeposit",
      meta: {
        title: '蜗牛预存款',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/woniu/preDeposit.vue")
    }, {
      path: "/frequencyLimit",
      name: "frequencyLimit",
      meta: {
        title: '呼叫限频',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/number/frequencyLimit.vue")
    }, {
      path: "/frequencyLimitCY",
      name: "frequencyLimitCY",
      meta: {
        title: 'CY呼叫限频',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/number/frequencyLimitCY.vue")
    }, {
      path: "/companyCardQuota",
      name: "companyCardQuota",
      meta: {
        title: '坐席配额',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/enterprise/companyCardQuota.vue")
    }, {
      path: "/djRebateList",
      name: "djRebateList",
      meta: {
        title: '返销记录',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/dijia/djRebateList.vue")
    }, {
      path: "/activationList",
      name: "activationList",
      meta: {
        title: '限制返档',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/dijia/activationList.vue")
    }, {
      path: "/DJAbnormalCallList",
      name: "DJAbnormalCallList",
      meta: {
        title: '迪加异常话单',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/dijia/DJAbnormalCallList.vue")
    }, {
      path: "/CCWNAbnormalCallList",
      name: "CCWNAbnormalCallList",
      meta: {
        title: '长城异常话单',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/woniu/CCWNAbnormalCallList.vue")
    }, {
      path: "/WNAbnormalCallList",
      name: "WNAbnormalCallList",
      meta: {
        title: '蜗牛异常话单',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/woniu/WNAbnormalCallList.vue")
    }, {
      path: "/WNAbnormalCallListCY",
      name: "WNAbnormalCallListCY",
      meta: {
        title: 'CY蜗牛异常话单',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/woniu/WNAbnormalCallListCY.vue")
    },
    {
      path: "/accountReview",
      name: "accountReview",
      meta: {
        title: '开户审核查询'
      },
      component: () => import("../views/system/accountReview.vue")
    },
    {
      path: "/workOrder",
      name: "workOrder",
      meta: {
        title: '工单管理',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/system/workOrder.vue")
    }, {
      path: "/agentSerial",
      name: "agentSerial",
      meta: {
        title: '代理商分配记录',
        permission: true,
        role: ['admin', 'oem']
      },
      component: () => import("../views/enterprise/agentSerial.vue")
    },
    // {
    // 	path: "/userSerial",
    // 	name: "userSerial",
    // 	meta: {
    // 		title: '员工分配记录',
    // 		permission: true,
    // 		role: ['admin', 'agent', 'subAgent',

    // 	},
    // 	component: () => import(
    // 		/* webpackChunkName: "table" */
    // 		"../views/userSerial.vue")
    // },
    {
      path: "/flowManagement",
      name: "flowManagement",
      meta: {
        title: '流水管理',
        permission: true,
        role: ['admin', 'oem', 'agent']
      },
      component: () => import("../views/package/flowManagement.vue")
    },
    {
      path: "/refundList",
      name: "refundList",
      meta: {
        title: '退款列表',
        permission: true,
        role: ['admin', 'oem']
      },
      component: () => import("../views/package/refundList.vue")
    },
    {
      path: "/stopPhone",
      name: "stopPhone",
      meta: {
        title: '号码停机',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/number/stopPhone.vue")
    }, {
      path: "/validate",
      name: "validate",
      meta: {
        title: '号码验证'
      },
      component: () => import("../views/number/validate.vue")
    },
    {
      path: "/blackList",
      name: "blackList",
      meta: {
        title: '黑名单'
      },
      component: () => import("../views/number/blackList.vue")
    },
    // {
    // 	path: "/userManual",
    // 	name: "userManual",
    // 	meta: {
    // 		title: '用户手册'
    // 	},
    // 	component: () => import(
    // 		/* webpackChunkName: "table" */
    // 		"../views/userManual.vue")
    // },
    {
      path: "/swipes",
      name: "swipes",
      meta: {
        title: 'APP轮播图'
      },
      component: () => import("../views/system/swipes.vue")
    },
    {
      path: "/afterSales",
      name: "afterSales",
      meta: {
        title: '售后信息',
        role: ['admin', 'oem']
      },
      component: () => import("../views/system/afterSales.vue")
    },
    {
      path: "/role",
      name: "role",
      meta: {
        title: '角色管理',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/enterprise/role.vue")
    }, {
      path: "/notice",
      name: "notice",
      meta: {
        title: '公告',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/system/notice.vue")
    },
    {
      path: "/addNotice",
      name: "addNotice",
      meta: {
        title: '发布公告',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/system/addNotice.vue")
    },
    {
      path: '/404',
      name: '404',
      meta: {
        title: '找不到页面'
      },
      component: () => import('../views/system/404.vue')
    }, {
      path: '/403',
      name: '403',
      meta: {
        title: '没有权限'
      },
      component: () => import('../views/system/403.vue')
    },
    {
      path: "/operationManual",
      name: "operationManual",
      meta: {
        title: '使用手册'
      },
      component: () => import("../views/system/operationManual.vue")
    }, {
      path: "/operationManual2",
      name: "operationManual2",
      meta: {
        title: '使用手册'
      },
      component: () => import("../views/system/operationManual2.vue")
    },
    {
      path: "/reportNumber",
      name: "reportNumber",
      meta: {
        title: '报备绿名单号码',
        permission: true,
        role: ['admin', 'oem', 'agent']
      },
      component: () => import("../views/number/reportNumber.vue")
    },
    {
      path: "/operationLog",
      name: "operationLog",
      meta: {
        title: '员工操作日志',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
      },
      component: () => import("../views/system/operationLog.vue")
    },
    {
      path: "/termOfValidity",
      name: "termOfValidity",
      meta: {
        title: '有效期管理',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
      },
      component: () => import("../views/number/termOfValidity.vue")
    },
    {
      path: "/setColor",
      name: "setColor",
      meta: {
        title: '设置主题',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/system/setColor.vue")
    },
    {
      path: "/packageList",
      name: "packageList",
      meta: {
        title: '套餐列表',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/package/packageList.vue")
    },
    {
      path: "/middleNumber",
      name: "middleNumber",
      meta: {
        title: '回拨中间号',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/number/middleNumber.vue")
    },
    {
      path: "/consumptionDetails",
      name: "consumptionDetails",
      meta: {
        title: '消费明细',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/package/consumptionDetails.vue")
    },
    {
      path: "/privateNumber",
      name: "privateNumber",
      meta: {
        title: '私人号码',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/number/privateNumber.vue")
    },
    {
      path: "/packageManagement",
      name: "packageManagement",
      meta: {
        title: '套餐管理',
        permission: true,
        role: ['admin', 'agent', 'company', 'subAgent']
      },
      component: () => import("../views/package/packageManagement.vue")
    },
    {
      path: "/packageManagementX",
      name: "packageManagementX",
      meta: {
        title: '套餐管理',
        permission: true,
        role: ['admin', 'agent', 'company', 'subAgent']
      },
      component: () => import("../views/package/packageManagementX.vue")
    }, {
      path: "/packageManagementXuser",
      name: "packageManagementXuser",
      meta: {
        title: '用户管理',
        permission: true,
        role: ['admin', 'agent', 'company', 'subAgent']
      },
      component: () => import("../views/package/packageManagementXuser.vue")
    }, {
      path: "/AXBBinding",
      name: "AXBBinding",
      meta: {
        title: '绑定查询',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/inventory/AXBBinding.vue")
    },
    {
      path: "/record2",
      name: "record2",
      meta: {
        title: '虚商通话记录',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/quality/record2.vue")
    },
    {
      path: "/AXBinventory",
      name: "AXBinventory",
      meta: {
        title: 'AXB库存',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/inventory/AXBinventory.vue")
    },
    {
      path: "/SJTXinventory",
      name: "SJTXinventory",
      meta: {
        title: '世纪通信库存',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/inventory/SJTXinventory.vue")
    },
    {
      path: "/purchaseOrderList",
      name: "purchaseOrderList",
      meta: {
        title: '采购列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/inventory/purchaseOrderList.vue")
    },
    {
      path: "/whiteCard",
      name: "whiteCard",
      meta: {
        title: '白卡入库',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/inventory/whiteCard.vue")
    },
    {
      path: "/SJinventory",
      name: "SJinventory",
      meta: {
        title: '世纪通信库存',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/inventory/SJinventory.vue")
    },
    {
      path: "/SJDeliveryRecord",
      name: "SJDeliveryRecord",
      meta: {
        title: '世纪通信库存记录',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/inventory/SJDeliveryRecord.vue")
    },
    {
      path: "/outboundRecord",
      name: "outboundRecord",
      meta: {
        title: '出库记录',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/inventory/outboundRecord.vue")
    },
    {
      path: "/inventoryList",
      name: "inventoryList",
      meta: {
        title: '库存列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/inventory/inventoryList.vue")
    },
    {
      path: "/inventorySetMenu",
      name: "inventorySetMenu",
      meta: {
        title: '库存套餐',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/inventory/inventorySetMenu.vue")
    },
    {
      path: "/earlyWarning",
      name: "earlyWarning",
      meta: {
        title: '预警规则',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/inventory/earlyWarning.vue")
    }, {
      path: "/purchaseList",
      name: "purchaseList",
      meta: {
        title: '已购号码',
        permission: true,
        role: ['admin', 'agent', 'company', 'subAgent']
      },
      component: () => import("../views/inventory/purchaseList.vue")
    }, {
      path: "/consultationDetailed",
      name: "consultationDetailed",
      meta: {
        title: '消费明细',
        permission: true,
        role: ['admin', 'agent', 'company', 'subAgent']
      },
      component: () => import("../views/package/consultationDetailed.vue")
    },
    {
      path: "/seating",
      name: "seating",
      meta: {
        title: '坐席数据',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/enterprise/seating.vue")
    },
    {
      path: "/userPhone",
      name: "userPhone",
      meta: {
        title: '账号登录记录',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/enterprise/userPhone.vue")
    },
    {
      path: "/remoteLogin",
      name: "remoteLogin",
      meta: {
        title: '位置异常',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/enterprise/remoteLogin.vue")
    },
    {
      path: "/jobManager",
      name: "jobManager",
      meta: { title: '定时任务管理' },
      role: ['admin'] ,// 只有 admin 能访问
      component: () => import("../views/job/JobManager.vue")
    },
    {
      path: "/callsNumber",
      name: "callsNumber",
      meta: {
        title: '电话邦放行次数',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/quality/callsNumber.vue")
    },
    {
      path: "/GMvirtualCommerce",
      name: "GMvirtualCommerce",
      meta: {
        title: '国美管理',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/guomei/GMvirtualCommerce.vue")
    },
    {
      path: "/WNvirtualCommerce",
      name: "WNvirtualCommerce",
      meta: {
        title: '蜗牛管理',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/woniu/WNvirtualCommerce.vue")
    },
    {
      path: "/enterpriseLimiting",
      name: "enterpriseLimiting",
      meta: {
        title: '企业限频',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/sip/enterpriseLimiting.vue")
    },
    {
      path: "/CYWNvirtualCommerce",
      name: "CYWNvirtualCommerce",
      meta: {
        title: 'CY蜗牛管理',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/woniu/CYWNvirtualCommerce.vue")
    },
    {
      path: "/DJvirtualCommerce",
      name: "DJvirtualCommerce",
      meta: {
        title: '迪加管理',
        permission: true,
        role: ['admin', 'agent'],
      },
      component: () => import("../views/dijia/DJvirtualCommerce.vue")
    },
    {
      path: "/CCvirtualCommerce",
      name: "CCvirtualCommerce",
      meta: {
        title: '长城管理',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/changcheng/CCvirtualCommerce.vue")
    },
    {
      path: "/gmAbnormalCallList",
      name: "gmAbnormalCallList",
      meta: {
        title: '国美异常话单',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/guomei/gmAbnormalCallList.vue")
    },
    {
      path: "/gmAbnormalNumber",
      name: "gmAbnormalNumber",
      meta: {
        title: '国美异常号码',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/guomei/gmAbnormalNumber.vue")
    },
    {
      path: "/highSeas",
      name: "highSeas",
      meta: {
        title: '公海数据',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/crm/highSeas.vue")
    },
    {
      path: "/advancedSearch",
      name: "advancedSearch",
      meta: {
        title: '找线索',
        permission: true,
        // role: ['admin'],
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/crm/advancedSearch.vue")
    }, {
      path: "/companySearch",
      name: "companySearch",
      meta: {
        title: '找企业',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/crm/companySearch.vue")
    }, {
      path: "/shopSearch",
      name: "shopSearch",
      meta: {
        title: '找店铺',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/crm/shopSearch.vue")
    }, {
      path: "/industryTemplate",
      name: "industryTemplate",
      meta: {
        title: '找行业',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/crm/industryTemplate.vue")
    }, {
      path: "/mapSearch",
      name: "mapSearch",
      meta: {
        title: '地图找客',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/crm/mapSearch.vue")
    }, {
      path: "/batchCheckCompany",
      name: "batchCheckCompany",
      meta: {
        title: '批量查询',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/crm/batchCheckCompany.vue")
    }, {
      path: "/poolAccount",
      name: "poolAccount",
      meta: {
        title: '寻迹通账号管理',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/crm/poolAccount.vue")
    },
    {
      path: "/guide",
      name: "guide",
      meta: {
        title: '指引',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/system/guide.vue")
    },
    {
      path: "/GM",
      name: "GM",
      meta: {
        title: '国美录音',
        permission: true,
        role: ['gm']
      },
      component: () => import("../views/quality/GM.vue")
    },
    {
      path: "/OEMset",
      name: "OEMset",
      meta: {
        title: 'OEM设置',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/system/OEMset.vue")
    },
    {
      path: "/OEMswiper",
      name: "OEMswiper",
      meta: {
        title: '登录轮播图',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/system/OEMswiper.vue")
    },
    {
      path: "/prestore",
      name: "prestore",
      meta: {
        title: '蜗牛预存款',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/woniu/prestore.vue")
    },
    {
      path: "/panelData",
      name: "panelData",
      meta: {
        title: '数据面板',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/system/panelData.vue")
    },
    {
      path: "/sipTemplate",
      name: "sipTemplate",
      meta: {
        title: '套餐列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/sip/sipTemplate.vue")
    },
    {
      path: "/enterpriseAllocation",
      name: "enterpriseAllocation",
      meta: {
        title: '套餐分配',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/sip/enterpriseAllocation.vue")
    },
    {
      path: "/specialServiceNumber",
      name: "specialServiceNumber",
      meta: {
        title: '号码列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/sip/specialServiceNumber.vue")
    },
    {
      path: "/FTConsumptionDetails",
      name: "FTConsumptionDetails",
      meta: {
        title: '账单明细',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/package/FTConsumptionDetails.vue")
    },
    {
      path: "/JobData",
      name: "JobData",
      meta: {
        title: '数据面板',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/job/JobData.vue")
    },

    {
      path: "/JobTemplate",
      name: "JobTemplate",
      meta: {
        title: '套餐列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/job/JobTemplate.vue")
    },
    {
      path: "/JobenterpriseAllocation",
      name: "JobenterpriseAllocation",
      meta: {
        title: '套餐分配',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/job/JobenterpriseAllocation.vue")
    },
    {
      path: "/JobspecialServiceNumber",
      name: "JobspecialServiceNumber",
      meta: {
        title: '号码列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/job/JobspecialServiceNumber.vue")
    },
    {
      path: "/UUtemplate",
      name: "UUtemplate",
      meta: {
        title: 'U友模版',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/package/UUtemplate.vue")
    },
    {
      path: "/JobFTConsumptionDetails",
      name: "JobFTConsumptionDetails",
      meta: {
        title: '账单明细',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/job/JobFTConsumptionDetails.vue")
    },
    {
      path: "/JobFTConsumptionDetails",
      name: "JobFTConsumptionDetails",
      meta: {
        title: '账单明细',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/job/JobFTConsumptionDetails.vue")
    },
    {
      path: "/addressErrList",
      name: "addressErrList",
      meta: {
        title: '位置异常',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/enterprise/addressErrList.vue")
    },

    {
      path: "/customerQualityControl",
      name: "customerQualityControl",
      meta: {
        title: '客户质量管理',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/crm/customerQualityControl.vue")
    },
    {
      path: "/tonglianPrecisionTube",
      name: "tonglianPrecisionTube",
      meta: {
        title: '云呼面板',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/search/tonglianPrecisionTube.vue")
    },
    {
      path: "/cdrBatchManagement",
      name: "cdrBatchManagement",
      meta: {
        title: '话批面板',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/cdrBatch/cdrBatchManagement.vue")
    },
    {
      path: "/cdrBatchList",
      name: "cdrBatchList",
      meta: {
        title: '套餐列表',
        permission: true,
        role: ['admin', 'agent'],
      },
      component: () => import("../views/cdrBatch/cdrBatchList.vue")
    },
    {
      path: "/cdrBatchAllocation",
      name: "cdrBatchAllocation",
      meta: {
        title: '企业套餐',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/cdrBatch/cdrBatchAllocation.vue")
    },
    {
      path: "/trumpetspecialServiceNumber",
      name: "trumpetspecialServiceNumber",
      meta: {
        title: '号码状态',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/trumpet/trumpetspecialServiceNumber.vue")
    },
    {
      path: "/cdrBatchType",
      name: "cdrBatchType",
      meta: {
        title: '号码状态',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/cdrBatch/cdrBatchType.vue")
    },
    {
      path: "/cdrBatchConsumptionDetails",
      name: "cdrBatchConsumptionDetails",
      meta: {
        title: '账单明细',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/cdrBatch/cdrBatchConsumptionDetails.vue")
    }, {
      path: "/cdrBatchPremium",
      name: "cdrBatchPremium",
      meta: {
        title: '溢价',
        permission: true,
        role: ['admin'],
      },
      component: () => import("../views/cdrBatch/cdrBatchPremium.vue")
    },
    {
      path: "/cdrBatchServer",
      name: "cdrBatchServer",
      meta: {
        title: '话批品牌',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/cdrBatch/cdrBatchServer.vue")
    },
    {
      path: "/quantitativeIntelligenceMonitoring",
      name: "quantitativeIntelligenceMonitoring",
      meta: {
        title: '通话数据管理',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/cdrBatch/quantitativeIntelligenceMonitoring.vue")
    },
    {
      path: "/trumpetTemplate",
      name: "trumpetTemplate",
      meta: {
        title: '套餐列表',
        permission: true,
        role: ['admin', 'agent'],
      },
      component: () => import("../views/trumpet/trumpetTemplate.vue")
    },
    {
      path: "/trumpetenterpriseAllocation",
      name: "trumpetenterpriseAllocation",
      meta: {
        title: '企业套餐',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/trumpet/trumpetenterpriseAllocation.vue")
    },
    {
      path: "/sipNumber",
      name: "sipNumber",
      meta: {
        title: '号码列表',
        permission: true,
        role: ['admin', 'agent', 'company'],
        visiable: true,
      },
      component: () => import("../views/sip/sipNumber.vue")
    }, {
      path: "/sipAccountPrice",
      name: "sipAccountPrice",
      meta: {
        title: '云呼号码价格',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/sip/sipAccountPrice.vue")
    }, {
      path: "/trumpetFTConsumptionDetails",
      name: "trumpetFTConsumptionDetails",
      meta: {
        title: '账单明细',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/trumpet/trumpetFTConsumptionDetails.vue")
    }, {
      path: "/premium",
      name: "premium",
      meta: {
        title: '溢价',
        permission: true,
        role: ['admin', 'agent'],
      },
      component: () => import("../views/package/premium.vue")
    }, {
      path: "/SIPServer",
      name: "SIPServer",
      meta: {
        title: '云呼服务器',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/sip/SIPServer.vue")
    },
    {
      path: "/gmQuery",
      name: "gmQuery",
      meta: {
        title: '国美查询',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/guomei/gmQuery.vue")
    },
    {
      path: "/gmRecharge",
      name: "gmRecharge",
      meta: {
        title: '国美充值',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/guomei/gmRecharge.vue")
    },
    {
      path: "/shutdownList",
      name: "shutdownList",
      meta: {
        title: '国美停机',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/guomei/shutdownList.vue")
    },
    {
      path: "/gmAbnormalCallListNew",
      name: "gmAbnormalCallListNew",
      meta: {
        title: '国美异常话单',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/guomei/gmAbnormalCallListNew.vue")
    },
    {
      path: "/telephoneInspection",
      name: "telephoneInspection",
      meta: {
        title: '关键词列表',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/quality/telephoneInspection.vue")
    },
    {
      path: "/telephoneInspectionType",
      name: "telephoneInspectionType",
      meta: {
        title: '类别管理',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/quality/telephoneInspectionType.vue")
    }, {
      path: "/telephoneInspectionList",
      name: "telephoneInspectionList",
      meta: {
        title: 'AI质检',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/quality/telephoneInspectionList.vue")
    }, {
      path: "/intentList",
      name: "intentList",
      meta: {
        title: '意向质检',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/quality/intentList.vue")
    }, {
      path: "/inspectionServer",
      name: "inspectionServer",
      meta: {
        title: '语音检测服务器',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/quality/inspectionServer.vue")
    },
    {
      path: "/newPage",
      name: "newPage",
      meta: {
        title: '测试页面',
        permission: true, // 如果需要权限控制
        role: ['admin', 'agent'] // 设置可访问的角色
      },
      component: () => import("../views/system/NewPage.vue")
    },
    {
      path: "/quartz-task-management",
      name: "QuartzTaskManagement",
      meta: {
        title: '定时任务管理',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/job/JobManager.vue")
    },
    {
      path: "/dxtPackageTopUpLog",
      name: "DxtPackageTopUpLog",
      meta: {
        title: '迪信通充值日志',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/system/DxtPackageTopUpLog.vue")
    },
    {
      path: "/dijiaNumberPool",
      name: "DijiaNumberPool",
      meta: {
        title: '迪迦号码池',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/dijia/DijiaNumberPool.vue")
    },
    {
      path: "/historyComplaint",
      name: "historyComplaint",
      meta: {
        title: '12321投诉趋势'
      },
      component: () => import("../views/system/historyComplaint.vue")
    }
  ]
}, {
  path: "/login",
  name: "Login",
  meta: {
    title: '登录',
    loginRequest: true
  },
  component: () => import("../views/system/Login.vue")
}];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('webName')) {
    document.title = `${to.meta.title} | ${localStorage.getItem('webName')}`;
  }
  const role = localStorage.getItem('ms_role');
  if (!role && to.path !== '/login') {
    next('/login');
  } else if (to.meta.permission) {
    // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    to.meta.role.indexOf(role) >= 0 ? next() : next('/403');
  } else {
    next();
  }
});

// 全局错误处理：chunk 加载失败时自动刷新页面
router.onError((error) => {
  const chunkFailed = /Loading chunk [\d]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/;
  if (chunkFailed.test(error.message)) {
    window.location.reload();
  }
});

export default router;